import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-port',
    templateUrl: './port.component.html',
    styleUrls: ['./port.component.less'],
})
export class PortComponent {
    @Input() id!: string;
    @Input() name!: string;
    @Input() stroke = '#000';

}
